angular.module('dnecom')
    .controller('StoreSettingsController', ["$scope", "$http", "notifications", "$location", "ErrorBag", "$uibModal", function ($scope, $http, notifications, $location, ErrorBag, $uibModal) {
        $scope.store = TemplateData.value('store');
        $scope.referralLinkInvalid = false;
        var originalStore = angular.copy($scope.store);

        $scope.adjustedTime = false;

        $scope.view_tab = $location.search().tab || 'General';

        $scope.formHolder = {};
        $scope.saving = false;

        $scope.taxClasses = TemplateData.value('taxClasses');

        var scrollToTop = function () {
            $('html,body').animate({scrollTop: $('.settings-container').offset().top}, 'slow');
        };

        var validateForm = function (form) {
            if (form.$invalid || form.$pending || ($scope.referralLinkInvalid && $scope.store.properties.badges.referralLink)) {
                form.$setTouched();

                scrollToTop();

                return false;
            }

            return true;
        };

        var saveSettings = function (form) {
            if (!validateForm(form)) {
                return false;
            }
            $scope.errors = {};
            $scope.serverErrors = {};

            $scope.saving = true;
            $http.put(
                Routing.generate('stores_update_settings', { id: $scope.store.id, group: $scope.view_tab }),
                $scope.store
            )
            .then(function (response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                notifications.success('Store settings saved.');

                $scope.$broadcast('store.settings.saved');

                if ($scope.store.properties
                    && $scope.store.properties.badges
                    && $scope.store.properties.badges.mcafeeEnabled
                    && !$scope.store.properties.badges.mcafeeSecured
                ) {
                    $scope.$broadcast('store.integrations.mcafee.changed');
                }
            }, function (response) {
                if (response.status == 422) {
                    notifications.danger('Form contains invalid data.');

                    $scope.serverErrors = ErrorBag.from(response.data.errors);
                } else {
                    notifications.danger('Request error.');
                }
            })
            .finally(function() {
                $scope.saving = false;
            });

            copyCurrentStore();

            return true;
        };

        var cancelSave = function () {
            $scope.store = angular.copy(originalStore);
        };

        var copyCurrentStore = function () {
            originalStore = angular.copy($scope.store);
        };

        var createDefaultContactValues = function () {
            if (!$scope.store.properties) {
                $scope.store.properties = {};
            }
            if (!$scope.store.properties.contact) {
                $scope.store.properties.contact = {};
                $scope.store.properties.contact.phoneDisplayOnMain = false;
                $scope.store.properties.contact.emailDisplayOnMain = false;
            }
        };

        $scope.changeTab = function(form, tab) {
            if (!angular.equals($scope.store, originalStore)) {
                if (confirm('Save changes? Otherwise it will be lost.')) {
                    if (!saveSettings(form)) {
                        return;
                    }
                } else {
                    cancelSave();
                }
            }

            $scope.view_tab = tab;
        };

        $scope.changeDisplayPhoneOnMainState = function () {
            createDefaultContactValues();
            $scope.store.properties.contact.phoneDisplayOnMain = !$scope.store.properties.contact.phoneDisplayOnMain;
        };
        $scope.changeDisplayEmailOnMainState = function () {
            createDefaultContactValues();
            $scope.store.properties.contact.emailDisplayOnMain = !$scope.store.properties.contact.emailDisplayOnMain;
        };
        $scope.save = function (form) {
            return saveSettings(form);
        };

        $scope.reset = function () {
            cancelSave();
            notifications.info('Store settings reset completed.');
        };

        $scope.storeChanged = function () {
            return !angular.equals($scope.store, originalStore);
        };

        $scope.$watch('store.timezone', function (newValue, oldValue) {
            try {
                $scope.adjustedTime = moment().tz(newValue).format('MMM D, YYYY, h:mm A');
            } catch (e) {
                $scope.adjustedTime = false;
            }
        });

        $scope.openSEOConfigurationModal = function (page, $event) {
            $event.preventDefault();
            console.log($scope.store.properties.pages);

            $uibModal.open({
                templateUrl: 'seoConfigurationModal.html',
                controller: 'SEOConfigurationModal',
                animation: true,
                windowClass: 'modal-primary',
                backdrop: 'static',
                resolve: {
                    seo: function () {
                        if (!_.isUndefined($scope.store.properties.pages[page]) && $scope.store.properties.pages[page].length > 0) {
                            return JSON.parse($scope.store.properties.pages[page]);
                        } else {
                            return {};
                        }
                    }
                }
            }).result.then(function (result) {
                $scope.store.properties.pages[page] = JSON.stringify(result);
            });
        };

        $scope.validateReferralLink = function () {
            if ($scope.store.properties.badges.referralLink) {
                $scope.referralLinkInvalid = !/^(?:http(s)?:\/\/)?(dashnexpowertech.com\/lifetime\/|dnpinvite.com|dashnex.com)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/.test($scope.store.properties.badges.referralLink);
            } else {
                $scope.referralLinkInvalid = false;
            }
        }
    }]);
